<template>
  <v-form ref="form" class="mt-3" v-model="valid">
    <v-row>
      <v-col cols="6">
        <v-text-field label="Nom" :rules="[rules.required]" v-model="material.name"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          :items="units"
          v-model="material.unit"
          label="Unité de mesure"
          :item-title="item => item.name + (item.description !== '' ? ' - ' + item.description : '')"
          item-value="id"
          :rules="[rules.required]"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          label="Prix de l'unité ($ CA)"
          v-model="material.unitPrice"
          :rules="[rules.digit]"
          type="number"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          label="Temps de la main d'oeuvre (heures)"
          v-model="material.laborConstant"
          :rules="[rules.digit]"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-select
          @update:model-value="changeHourlyRates"
          :items="labors"
          v-model="material.labor"
          label="Corps de métier"
          item-title="name"
          item-value="id"
          :rules="[rules.required]"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        {{ formatLaborRateFrom(material.labor) }}
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { GetAll } from '@/_services/units';
import { GetLabors } from '@/_services/labors';
export default {
  name: 'ModalCustomMaterialInformationForm',
  props: {
    material: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
    forceResetForm: {
      type: Boolean,
      required: true,
    },
    formValid: { type: Boolean, required: true },
  },
  data() {
    return {
      valid: this.formValid,
      units: [],
      labors: [],
      rules: {
        required: value => !!value || 'Champ requis.',
        digit: value => {
          const pattern = /^\d*(\.\d+)?$/;
          if (pattern.test(value) && Number.isFinite(Number.parseFloat(value))) {
            return true;
          } else if (value === null || value === '') {
            return true;
          }
          return 'Coût invalide.';
        },
      },
    };
  },
  methods: {
    getUnits() {
      GetAll().then(rep => {
        this.units = rep;
      });
    },
    getLabors() {
      GetLabors().then(rep => {
        this.labors = rep;
      });
    },
    changeHourlyRates(laborId) {
      const labor = this.labors.find(labor => labor.id === laborId);
      this.material.laborHourlyRate = labor ? this.formatLaborRate(labor) : '';
    },
    formatLaborRateFrom(id) {
      const labor = this.labors.find(x => x.id === id);
      if (labor) {
        return this.formatLaborRate(labor);
      }
      return '';
    },
    formatLaborRate(labor) {
      return `${this.formatTextRate(labor.residentialCost)} - ${this.formatTextRate(
        labor.commercialCost,
      )} - ${this.formatTextRate(labor.industrialCost)} - ${this.formatTextRate(labor.civilEngineeringCost)} `;
    },
    formatTextRate(rate) {
      const text = rate || 'n/a';
      return rate ? text + '$' : text;
    },
    formIsValid(material) {
      return material.name.trim() !== '' && material.unit !== null && material.labor !== null;
    },
    resetForm() {
      this.$refs.form.resetValidation();
    },
  },
  watch: {
    show(val) {
      if (val === true) {
        this.getUnits();
        this.getLabors();
      }
    },
    forceResetForm(val) {
      if (val) {
        this.resetForm();
        this.$emit('update-force-reset-form', false);
      }
    },
    material: {
      handler(newVal) {
        if (this.formIsValid(newVal)) {
          this.$emit('update-form-validity', true);
        } else {
          this.$emit('update-form-validity', false);
        }
      },
      deep: true,
    },
  },
};
</script>
